import { useConfigContext } from 'contexts/config';

export default (competitionEligibilityFilter: string | undefined) => {
  const {
    so5: { competitionEligibilityAlgoliaFilters },
  } = useConfigContext();

  if (!competitionEligibilityFilter || !competitionEligibilityAlgoliaFilters)
    return null;

  return competitionEligibilityAlgoliaFilters[competitionEligibilityFilter];
};
